import { applicationContext } from '@/core/context/applicationContext';
import { useContext } from 'react';

export const useApplicationContext = () => {
  return useContext(applicationContext);
};
